/**
 * Secure API Configuration
 * Obfuscates API endpoints and provides secure request methods
 */

import { deobfuscateString, secureFetch } from './security';

// Obfuscated API URL (use obfuscateString in security.js to generate)
// Original: https://panel.work-redbull.com
const OBFUSCATED_API_URL = 'GxEXBQFTW1ZdCgscQRxHXUYYSBEQFgsBFUFFBhZA';

export const getApiUrl = () => {
  if (process.env.NODE_ENV === 'development') {
    return 'http://localhost:3001';
  }
  
  try {
    return deobfuscateString(OBFUSCATED_API_URL);
  } catch (error) {
    console.error('API configuration error');
    return null;
  }
};

// Secure API call wrapper
export const apiRequest = async (endpoint, options = {}) => {
  const apiUrl = getApiUrl();
  
  if (!apiUrl) {
    throw new Error('API configuration error');
  }
  
  const url = `${apiUrl}${endpoint}`;
  
  try {
    const response = await secureFetch(url, {
      ...options,
      credentials: 'include', // Include cookies
    });
    
    if (!response.ok) {
      throw new Error(`API Error: ${response.status}`);
    }
    
    return await response.json();
  } catch (error) {
    console.error('API request failed:', error);
    throw error;
  }
};

export default {
  getApiUrl,
  apiRequest
};

